import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode } from "vue";
const _hoisted_1 = { class: "col-12 bg-white border rounded pt-3" };
const _hoisted_2 = ["onClick"];
const _hoisted_3 = { class: "col-9 custom-control custom-radio" };
const _hoisted_4 = ["disabled", "checked", "id", "value"];
const _hoisted_5 = ["for"];
const _hoisted_6 = ["innerHTML"];
const _hoisted_7 = { class: "col-3 text-right pl-0" };
const _hoisted_8 = ["src", "alt"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("div", {
        id: "payment_type_selection",
        class: _normalizeClass(["col-12 mb-4", _ctx.currentPaymentType ? '' : 'is-invalid'])
    }, [
        _createElementVNode("div", _hoisted_1, [
            _cache[1] || (_cache[1] = _createStaticVNode("<div class=\"row border-bottom\" data-v-ce7f9d60><div class=\"col-12 mb-2\" data-v-ce7f9d60><div class=\"font7\" data-v-ce7f9d60>Schritt 3 von 3</div></div><div class=\"col-12\" data-v-ce7f9d60><h2 class=\"h5 mb-3\" data-v-ce7f9d60>Wie möchtest Du bezahlen?</h2></div></div>", 1)),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.payment_types, (payment_type) => {
                return (_openBlock(), _createElementBlock("div", {
                    class: "row pt-3 pb-2 pl-4 border-bottom",
                    key: `payment_${payment_type.id}`,
                    onClick: ($event) => (_ctx.sendeZahlungsart(payment_type))
                }, [
                    _createElementVNode("div", _hoisted_3, [
                        _createElementVNode("input", {
                            type: "radio",
                            class: "custom-control-input",
                            disabled: payment_type.disabled,
                            checked: !payment_type.disabled && _ctx.currentPaymentType && payment_type.id === _ctx.currentPaymentType.id,
                            id: `payment_type_input_${payment_type.id}`,
                            value: payment_type.id
                        }, null, 8, _hoisted_4),
                        _createElementVNode("label", {
                            class: "custom-control-label green-radio pointerhover w-100 h-100",
                            for: `payment_type_input_${payment_type.id}`
                        }, [
                            _createTextVNode(_toDisplayString(payment_type.title) + " ", 1),
                            _cache[0] || (_cache[0] = _createElementVNode("br", null, null, -1)),
                            _createElementVNode("span", {
                                class: "font8-responsive",
                                innerHTML: payment_type.description
                            }, null, 8, _hoisted_6)
                        ], 8, _hoisted_5)
                    ]),
                    _createElementVNode("div", _hoisted_7, [
                        _createElementVNode("img", {
                            class: "font7 border rounded d-inline-block p-1 payment-image",
                            src: payment_type.image_path,
                            alt: payment_type.title
                        }, null, 8, _hoisted_8)
                    ])
                ], 8, _hoisted_2));
            }), 128))
        ])
    ], 2));
}
